import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  search,
  create,
  update,
  getById,
  makeActive,
  makeInActive,
  getSelectListInsurancePolicy
} from './api';
import * as InsurancePolicyType from './constants';
import * as NotifyActionType from '../constants/notification-action-type';

export function* getByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: InsurancePolicyType.GET_INSURANCE_POLICY_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: InsurancePolicyType.SEARCH_INSURANCE_POLICY_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createAsync(action) {

  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: InsurancePolicyType.SEARCH_INSURANCE_POLICY_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Insurance policy created' })
    ];
  } else {
    yield put({ type: InsurancePolicyType.ADD_EDIT_INSURANCE_POLICY_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* updateAsync(action) {

  const result = yield call(update, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: InsurancePolicyType.SEARCH_INSURANCE_POLICY_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: InsurancePolicyType.ADD_EDIT_INSURANCE_POLICY_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeActiveAsync(action) {

  const result = yield call(makeActive, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: InsurancePolicyType.SEARCH_INSURANCE_POLICY_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* makeInActiveAsync(action) {

  const result = yield call(makeInActive, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: InsurancePolicyType.SEARCH_INSURANCE_POLICY_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* getSelectListInsurancePolicyAsync(action) {

  const result = yield call(getSelectListInsurancePolicy, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: InsurancePolicyType.GET_SELECT_LIST_INSURANCE_POLICY_SUCCESS, data: result.data })
    ];

    if (action.callback) { action.callback(); }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export default function* WatchInsurancePolicies() {
  yield all([
    takeLatest(InsurancePolicyType.SEARCH_INSURANCE_POLICY_ASYNC, searchAsync),
    takeLatest(InsurancePolicyType.GET_INSURANCE_POLICY_BY_ID_ASYNC, getByIdAsync),
    takeEvery(InsurancePolicyType.CREATE_INSURANCE_POLICY_ASYNC, createAsync),
    takeEvery(InsurancePolicyType.UPDATE_INSURANCE_POLICY_ASYNC, updateAsync),
    takeEvery(InsurancePolicyType.MAKE_ACTIVE_INSURANCE_POLICY_ASYNC, makeActiveAsync),
    takeEvery(InsurancePolicyType.MAKE_INACTIVE_INSURANCE_POLICY_ASYNC, makeInActiveAsync),
    takeEvery(InsurancePolicyType.GET_SELECT_LIST_INSURANCE_POLICY_ASYNC, getSelectListInsurancePolicyAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Insurance/saga.js